<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { api } from '../api'

const emit = defineEmits(['close', 'success'])
const state = ref('loading'), qr = ref(''), env = ref(''), message = ref('正在生成小程序码'), timer = ref(null)
const labels = { develop: '开发版', trial: '体验版', release: '正式版' }
const clearPolling = () => { if (timer.value) clearInterval(timer.value); timer.value = null }

const createQrCode = async () => {
  clearPolling()
  state.value = 'loading'
  message.value = qr.value ? '正在刷新二维码…' : '正在生成小程序码'
  try {
    const data = await api.createScan()
    qr.value = data.qr
    env.value = data.env
    state.value = 'waiting'
    message.value = '请使用微信扫描，并在小程序内确认'
    timer.value = setInterval(async () => {
      try {
        const result = await api.scanStatus(data.id)
        state.value = result.status
        if (result.status === 'waiting') message.value = '请使用微信扫描，并在小程序内确认'
        if (result.status === 'scanned') message.value = '已扫码，请在小程序内确认'
        if (result.status === 'confirmed') {
          localStorage.setItem('token', result.token)
          clearPolling()
          state.value = 'confirmed'
          message.value = '登录成功，正在进入网站…'
          setTimeout(() => emit('success'), 650)
        }
        if (result.status === 'expired') {
          clearPolling()
          state.value = 'expired'
          message.value = '二维码已过期，点击二维码重新生成'
        }
      } catch {
        clearPolling()
        state.value = 'error'
        message.value = '登录状态暂时无法获取，请重新生成'
      }
    }, 1600)
  } catch {
    state.value = 'error'
    message.value = '登录服务暂时不可用，请稍后重试'
  }
}

onMounted(createQrCode)
onBeforeUnmount(clearPolling)
</script>

<template>
  <div class="dialog-backdrop" @click.self="emit('close')">
    <section class="login-dialog" role="dialog" aria-modal="true">
      <button class="dialog-close" @click="emit('close')">×</button>
      <div class="scan-icon">{{ state === 'confirmed' ? '✓' : '⌗' }}</div>
      <h2>{{ state === 'confirmed' ? '登录成功' : '微信扫码登录' }}</h2>
      <p aria-live="polite">{{ message }}</p>
      <div v-if="state !== 'error' && state !== 'confirmed'" class="qr-frame" :class="{ expired: state === 'expired' }" @click="state === 'expired' && createQrCode()">
        <img v-if="qr" :src="qr" alt="微信小程序登录码"><span v-else class="loader"></span>
        <button v-if="state === 'expired'" class="qr-expired" aria-label="二维码已过期，点击重新生成"><b>↻</b><span>二维码已过期</span><small>点击重新生成</small></button>
      </div>
      <div v-else-if="state === 'confirmed'" class="login-success-mark">✓</div>
      <button v-else class="button login-retry" @click="createQrCode">重新生成</button>
      <span class="env-badge" v-if="env && state !== 'confirmed'">当前：{{ labels[env] }}</span>
      <p class="privacy-note">扫码仅用于验证身份，不会读取或上传您的照片。</p>
    </section>
  </div>
</template>
